module.exports = __webpack_public_path__ + "static/media/PHE_Temperature_Sensor_2.16d47609.svg";